import { render, staticRenderFns } from "./CortexLightIcon.vue?vue&type=template&id=920ff71c&"
import script from "./CortexLightIcon.vue?vue&type=script&lang=ts&"
export * from "./CortexLightIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports